import * as React from "react"
const SvgRefresh = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 20.143q-3.35 0-5.675-2.325T4 12.143t2.325-5.675T12 4.143q1.725 0 3.3.712A7.6 7.6 0 0 1 18 6.893v-1.75q0-.425.288-.713A.97.97 0 0 1 19 4.143a.97.97 0 0 1 .712.287q.288.288.288.713v5q0 .424-.288.712a.97.97 0 0 1-.712.288h-5a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287h3.2a5.84 5.84 0 0 0-2.188-2.2 5.93 5.93 0 0 0-3.012-.8q-2.5 0-4.25 1.75T6 12.143t1.75 4.25 4.25 1.75q1.699 0 3.113-.863a5.95 5.95 0 0 0 2.187-2.312 1.07 1.07 0 0 1 .563-.488q.362-.137.737-.012a.9.9 0 0 1 .575.525q.175.399-.025.75a8.1 8.1 0 0 1-2.925 3.2q-1.9 1.2-4.225 1.2" />
  </svg>
)
export default SvgRefresh
